import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { HomeComponent } from './home/home.component';
import { ResumeComponent } from './resume/resume.component';
import { PublicationsComponent } from './publications/publications.component';
import { DimensionalanalysisComponent } from './dimensionalanalysis/dimensionalanalysis.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMenuModule } from '@angular/material/menu';
import { GascalcComponent } from './gascalc/gascalc.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { IsentropicFlowMdlModule } from './isentropic-flow-mdl/isentropic-flow-mdl.module';
import { RpeIsentMdlModule } from './rpe-isent-mdl/rpe-isent-mdl.module';
import { PropulsionComponent } from './propulsion/propulsion.component';
import { AerocalcComponent } from './aerocalc/aerocalc.component';
import { RpecalcComponent } from './rpecalc/rpecalc.component';
import { ThermoComponent } from './thermo/thermo.component'
import { GcNormshockModule } from './gc-normshock/gc-normshock.module';


import { RpeNspMdlModule } from './rpe-nsp-mdl/rpe-nsp-mdl.module';
import { RpeNstabComponent } from './rpe-nsp-mdl/rpe-nstab/rpe-nstab.component';
import { DeflectWeakComponent } from './rpe-oblique/deflect-weak/deflect-weak.component';
import { DeflectStrongComponent } from './rpe-oblique/deflect-strong/deflect-strong.component';
import { ShockAngleComponent } from './rpe-oblique/shock-angle/shock-angle.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ResumeComponent,
    PublicationsComponent,
    DimensionalanalysisComponent,
    GascalcComponent,
    PropulsionComponent,
    AerocalcComponent,
    ThermoComponent,
  
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatMenuModule,
    MatExpansionModule,
    IsentropicFlowMdlModule,
    ReactiveFormsModule,
    GcNormshockModule,
    RpeIsentMdlModule,
    RpeNspMdlModule,
    RpeNstabComponent, // Add the standalone component to imports
    RpecalcComponent

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
